<template>
  <div class="upload">
    <BaseUploadImage
      accept="image/jpeg,image/png"
      multiple
      @add="onFile"
    />

    <div class="gallery">
      <div
        v-for="(image, index) of computedImages"
        :key="index"
        class="gallery-item"
      >
        <div
          class="gallery-item__close"
          @click="onDelete(index)"
        >
          &#10006;
        </div>
        <AppGalleryItem
          :photo="image"
          class="gallery-item__photo"
        />
      </div>
    </div>

    <div class="panel">
      <BaseButton
        @click="onNext"
      >
        Сохранить
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseUploadImage from '@/components/UploadImage'
import AppGalleryItem from '@/components/AppGalleryItem'
import BaseButton from '@/components/Base/BaseButton'

export default {
  name: 'AppPhotoUpload',
  components: {
    AppGalleryItem,
    BaseUploadImage,
    BaseButton
  },
  computed: {
    computedImages () {
      const images = this.$store.getters['createField/imagesStep/blobImages']
      return images.map(item => {
        return URL.createObjectURL(item)
      })
    }
  },
  methods: {
    onFile (event) {
      const files = event.target.files
      const result = []

      for (const file of files) {
        result.push(
          new Blob([file], { type: file.type })
        )
      }

      this.$store.state.createField.imagesStep.blobImages = result
    },
    onDelete (index) {
      this.$store.state.createField.imagesStep.blobImages.splice(index, 1)
    },
    onNext () {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  .gallery {
    display: flex;
    margin-top: 24px;
    flex-wrap: wrap;

    &-item {
      margin-right: 20px;
      margin-bottom: 20px;
      width: 200px;
      position: relative;

      &__close {
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: red;
        cursor: pointer;
        user-select: none;
      }
    }
  }

  .panel {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
